module.exports = "<app-layout>\n \n</app-layout>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/views/dashboard/dashboard.component.html
// module id = ./src/app/components/views/dashboard/dashboard.component.html
// module chunks = main